var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.444444C0 0.198987 0.198987 0 0.444444 0H7.55556C7.80102 0 8 0.198987 8 0.444444V1.59368C8 1.71156 7.95316 1.8246 7.86982 1.90795L5.01907 4.75871C4.93573 4.84204 4.88889 4.95511 4.88889 5.07298V6.01512C4.88889 6.14772 4.83621 6.2749 4.74244 6.36867L3.96466 7.14645C3.64968 7.46143 3.11111 7.23835 3.11111 6.79289V5.07298C3.11111 4.95511 3.06428 4.84204 2.98094 4.75871L0.130173 1.90795C0.0468267 1.8246 0 1.71156 0 1.59368V0.444444Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOrange);
export default __webpack_public_path__ + "static/media/filter_orange.7bb903337cf4eb409629a23520792594.svg";
export { ForwardRef as ReactComponent };